import React, {useState} from 'react';
import QuickStats from './quick-stats/quick-stats';
import AboutStudents from './about-students';
import AboutAdmissions from './about-admissions';
import AboutFutureSalary from './about-future-salary';
import AboutGraduationRates from './about-graduation-rates';
import AboutOverview from './about-overview/about-overview';
import SimilarCollegesCard from 'shared/college-profile/containers/similar-colleges-card';
import AboutCostAndFinancialAid from './cost-and-financial-aid';
import AboutTestimonials from './about-testimonials/about-testimonials';
import {TestimonialData} from './about-testimonials/testimonial';
import {AboutCollegeProfileData as College} from 'src/types/college-profile';
import {EducationPhase} from 'src/types/enums';

interface Props {
  college: College;
  testimonials: TestimonialData[];
  userInfo: {
    highSchoolFrlPercentage: number;
    highSchoolInfo: {lunchPlan?: string; graduationYear?: number | null; gpa: number};
    image: string;
    householdIncomeRange: string;
    user: string;
    [key: string]: unknown;
  };
  userState: string;
  showGPASection: boolean;
  showTestsSection: boolean;
  showCostsAndFinancialAid: boolean;
  showTestScores: boolean;
  nonStudent?: boolean;
}

const AboutCollege = ({
  college,
  testimonials,
  userInfo,
  userState,
  showGPASection,
  showTestsSection,
  showCostsAndFinancialAid,
  showTestScores,
  nonStudent,
}: Props) => {
  const collegeHasGraduates = useState(
    [college.fourYearGraduationRate, college.sixYearGraduationRate].some((rate) => rate && rate > 0)
  );

  return (
    <ul className="college-profile-panel-body" aria-label={`About ${name}`}>
      <QuickStats college={college} userInfo={userInfo} />
      <AboutOverview college={college} userType={userInfo.user as EducationPhase} />
      {showCostsAndFinancialAid && (
        <AboutCostAndFinancialAid college={college} userState={userState} userInfo={userInfo} />
      )}
      <AboutStudents college={college} />
      {Array.isArray(testimonials) && testimonials.length !== 0 && (
        <AboutTestimonials testimonials={testimonials} nonStudent={nonStudent} />
      )}
      <AboutAdmissions
        college={college}
        userInfo={userInfo}
        showTestsSection={showTestsSection}
        showGPASection={showGPASection}
        showTestScores={showTestScores}
      />
      {collegeHasGraduates && (
        <div>
          <AboutGraduationRates college={college} />
          <AboutFutureSalary
            college={college}
            nationalCollegeData={college.nationalCollegeData}
            isOpen
          />
        </div>
      )}
      <SimilarCollegesCard />
    </ul>
  );
};

export default AboutCollege;
